module.exports = __webpack_public_path__ + "static/img/echnologynew1.76b6ccfd.png";